export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "斗罗大陆漫画完结没有？",
    a: "《斗罗大陆》漫画的主线剧情已推进到成神大结局，主篇故事走向圆满落幕。本篇围绕唐三从双生武魂觉醒到成就海神之位的完整历程展开，大结局章节已整理收录在追更话数中，读者可以直接从完结话数回看收尾剧情。",
  },
  {
    q: "斗罗大陆漫画更新到哪了、第几话？",
    a: "本站追更话数页会按剧情阶段整理主线进度与关键话数，主篇已收录至完结篇。你可以通过话数列表快速定位当前追到哪一话，并结合最新剧情板块了解该阶段的故事走向，避免来回翻找。",
  },
  {
    q: "漫画和小说、动画的剧情一样吗？",
    a: "三者都源自同一世界观，主线脉络一致，但改编载体在节奏、细节与部分情节安排上会有差异。漫画以分镜和画面呈现战斗与情感，适合喜欢静态沉浸式阅读的读者；动画则侧重动态表现。本站以漫画为追踪主线，剧情内容与原著小说保持一致。",
  },
  {
    q: "在哪里可以追更斗罗大陆漫画？",
    a: "正规漫画平台均可在线阅读，建议优先选择官方授权的渠道，以获得清晰画质与稳定更新。本站不做内容搬运，仅提供追更进度、话数整理与最新剧情速览，方便你快速掌握进度后再前往平台阅读。",
  },
  {
    q: "追更提醒订阅有什么用？",
    a: "订阅后，当主篇后续剧情或本站追更整理更新时，会通过邮件向你发送提醒，无需每天手动检查进度，省心不迷路。订阅是完全自愿的，你可以随时在邮件中退订。",
  },
];